export const scammerData = {
  telephone: {
    title: 'What was the nature of the call?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/24ad45a2ea4b-tooliconquestionconvo.jpg',
    },
  },
  online: {
    title: 'Can you tell us more about what type of scam this was?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/24ad45a2ea4b-tooliconquestionconvo.jpg',
    },
  },
  house: {
    title: 'Who did the person claim to be?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/24ad45a2ea4b-tooliconquestionconvo.jpg',
    },
  },
  social: {
    title: 'Which social media platform?',
    imgObj: {
      alt: '',
      src: 'https://media.product.which.co.uk/prod/images/original/24ad45a2ea4b-tooliconquestionconvo.jpg',
    },
  },
}
